import SignIn from '../../components/organisms/forms/SignIn';
import SignUp from '../../components/organisms/forms/SignUp';
import Logout from '../../views/Logout';
import Forgot from '../../views/Reinitialiser/Forgot';
import Reinitialiser from '../../views/Reinitialiser/Reinitialiser';
import SuccessPage from '../../views/SuccessPage';
import pages from '../pages';

export const unloggedRoutes = [
  {
    path: pages.SIGN_UP.path,
    component: SignUp
  },
  {
    path: pages.SIGN_IN.path,
    component: SignIn
  },
  {
    path: pages.SUCCESS.path,
    component: SuccessPage
  },
  {
    path: pages.REINITIALISER.path,
    component: Forgot
  },
  {
    path: pages.CONFIRM_REINIT.path,
    component: Reinitialiser
  },
  {
    path: pages.LOGOUT.path,
    component: Logout
  }
];
